export default __webpack_public_path__ + "static/media/money.36b2f446.svg";